import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Center, Spinner, Box } from '@chakra-ui/react';
import { CardCarouselProps } from '@src/components/sco/CardCarousel';
import { PodcastHeroCard } from '@src/components/sco/Education/PodcastLanding/PodcastHeroCard';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { Query } from '@src/graphql-types';
import { gql, gqlArgs, gqlVars } from '@src/lib/gql';
type PodcastHeroProps = {
  keywords?: string;
  termSlugs?: string[];
  carouselProps?: CardCarouselProps;
};
export const PodcastHero = props => {
  const $ = _c(15);
  useBreakpointContext();
  let t0;
  if ($[0] !== props) {
    t0 = PodcastHero.queries.podcastEpisodes(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.keywords || $[3] !== props.termSlugs) {
    t1 = {
      variables: {
        keywords: props.keywords,
        termSlugs: props.termSlugs
      }
    };
    $[2] = props.keywords;
    $[3] = props.termSlugs;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const query = useQuery(t0, t1);
  if (query.loading || !query.data) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Center><Spinner /></Center>;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  if (query.error) {
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <>Error</>;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  const episode = query.data.podcastEpisodes[0];
  const t2 = episode.posterImage?.url;
  const t3 = `/podcast/${episode.slug}`;
  let t4;
  if ($[7] !== episode.description || $[8] !== episode.megaphoneLink || $[9] !== episode.number || $[10] !== episode.title || $[11] !== episode.transistorLink || $[12] !== t2 || $[13] !== t3) {
    t4 = <Box bgImage="linear-gradient(transparent, {colors.colorPalette.muted/50})" boxShadow="inset 0px -20px 10px -20px rgba(0, 0, 0, 0.15)" position="relative" width="full"><PodcastHeroCard description={episode.description} latest={true} megaphoneLink={episode.megaphoneLink} number={episode.number} posterImage={t2} title={episode.title} transistorLink={episode.transistorLink} url={t3} /></Box>;
    $[7] = episode.description;
    $[8] = episode.megaphoneLink;
    $[9] = episode.number;
    $[10] = episode.title;
    $[11] = episode.transistorLink;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
PodcastHero.fragments = {
  PodcastEpisode: () => gql`
    fragment _ on PodcastEpisode {
      id
      title
      description
      slug
      posterImage {
        id
        url(transformation: { image: { resize: { fit: max, width: 1000 } } })
        altText
        height
        width
      }
      megaphoneLink
      transistorLink
      number
      slug
    }
  `
};
PodcastHero.queries = {
  podcastEpisodes: (props: PodcastHeroProps) => {
    const vars = gqlVars({
      '$keywords: String': props.keywords,
      '$termSlugs: [String]': props.termSlugs?.length > 0
    });
    const where = gqlArgs({
      'where: ': {
        '_search: $keywords': props.keywords,
        'terms_some: { slug_in: $termSlugs }': props.termSlugs?.length > 0
      }
    });
    return gql`
      query ${vars} {
        podcastEpisodes(
          orderBy: number_DESC
          first: 5
          ${where}
        ) {
          id
          ${PodcastHero.fragments.PodcastEpisode()}
        }
      }
    `;
  }
};